module.exports = __webpack_public_path__ + "img/mobileintegrated3.4bd64b92.png";